/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AgencyConfiguration,
    AgencyConfigurationFromJSON,
    AgencyConfigurationToJSON,
    AgencyFormData,
    AgencyFormDataFromJSON,
    AgencyFormDataToJSON,
    AgencyFormValidationData,
    AgencyFormValidationDataFromJSON,
    AgencyFormValidationDataToJSON,
    ImportDataResponse,
    ImportDataResponseFromJSON,
    ImportDataResponseToJSON,
} from '../models';

export interface ApiAgencyFormConfigurationGetRequest {
    brand?: number;
    market?: string;
}

export interface ApiAgencyFormCreatePostRequest {
    agencyFormData?: AgencyFormData;
}

export interface ApiAgencyFormDataGetRequest {
    id?: string;
}

export interface ApiAgencyFormUpdatePostRequest {
    agencyFormData?: AgencyFormData;
}

export interface ApiAgencyFormValidatePostRequest {
    agencyFormData?: AgencyFormData;
}

/**
 * no description
 */
export class AgencyFormApi extends runtime.BaseAPI {

    /**
     */
    async apiAgencyFormConfigurationGetRaw(requestParameters: ApiAgencyFormConfigurationGetRequest): Promise<runtime.ApiResponse<AgencyConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.brand !== undefined) {
            queryParameters['brand'] = requestParameters.brand;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AgencyForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AgencyConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiAgencyFormConfigurationGet(requestParameters: ApiAgencyFormConfigurationGetRequest): Promise<AgencyConfiguration> {
        const response = await this.apiAgencyFormConfigurationGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiAgencyFormCreatePostRaw(requestParameters: ApiAgencyFormCreatePostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AgencyForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AgencyFormDataToJSON(requestParameters.agencyFormData),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiAgencyFormCreatePost(requestParameters: ApiAgencyFormCreatePostRequest): Promise<string> {
        const response = await this.apiAgencyFormCreatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiAgencyFormDataGetRaw(requestParameters: ApiAgencyFormDataGetRequest): Promise<runtime.ApiResponse<AgencyFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AgencyForm/Data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AgencyFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiAgencyFormDataGet(requestParameters: ApiAgencyFormDataGetRequest): Promise<AgencyFormData> {
        const response = await this.apiAgencyFormDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiAgencyFormImportPostRaw(): Promise<runtime.ApiResponse<ImportDataResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AgencyForm/import`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ImportDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAgencyFormImportPost(): Promise<ImportDataResponse> {
        const response = await this.apiAgencyFormImportPostRaw();
        return await response.value();
    }

    /**
     */
    async apiAgencyFormUpdatePostRaw(requestParameters: ApiAgencyFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AgencyForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AgencyFormDataToJSON(requestParameters.agencyFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiAgencyFormUpdatePost(requestParameters: ApiAgencyFormUpdatePostRequest): Promise<void> {
        await this.apiAgencyFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiAgencyFormValidatePostRaw(requestParameters: ApiAgencyFormValidatePostRequest): Promise<runtime.ApiResponse<AgencyFormValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AgencyForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AgencyFormDataToJSON(requestParameters.agencyFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AgencyFormValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiAgencyFormValidatePost(requestParameters: ApiAgencyFormValidatePostRequest): Promise<AgencyFormValidationData> {
        const response = await this.apiAgencyFormValidatePostRaw(requestParameters);
        return await response.value();
    }

}
